// export const BASE_URL = 'https://newtestapi.fmcnetwork.net';
export const BASE_URL = 'https://fmcapi.fmcnetwork.net';

export const getProviderTypes = async () => {
  const response = await fetch(
    `${BASE_URL}/providerempanelment/ProviderType`,
    {
      method: 'GET',
      headers: {
        accept: '*/*',
      },
    }
  );

  if (!response.ok) {
    throw new Error('Failed to fetch provider types');
  }

  return response.json();
};


export const getHealthAuthorities = async () => {
  const response = await fetch(
    `${BASE_URL}/providerempanelment/HealthAuthority`,
    {
      method: 'GET',
      headers: { accept: '*/*' },
    }
  );

  if (!response.ok) {
    throw new Error('Failed to fetch health authorities');
  }

  const result = await response.json();
  return result.data || [];
};


export const getEmirates = async () => {
  const response = await fetch(
    `${BASE_URL}/providerempanelment/Emirates`,
    {
      method: 'GET',
      headers: { accept: '*/*' },
    }
  );

  if (!response.ok) {
    throw new Error('Failed to fetch emirates');
  }

  const result = await response.json();
  return result.data || [];
};


export const getCitiesByState = async (stateId) => {
  if (!stateId) return [];

  const response = await fetch(
    `${BASE_URL}/providerempanelment/City?state_ID=${stateId}`,
    {
      method: 'GET',
      headers: { accept: '*/*' },
    }
  );

  if (!response.ok) {
    throw new Error('Failed to fetch cities');
  }

  const result = await response.json();
  return result.data || [];
};



export const getAreasByCity = async (cityId) => {
  if (!cityId) return [];

  const response = await fetch(
    `${BASE_URL}/providerempanelment/Area?cityId=${cityId}`,
    {
      method: 'GET',
      headers: { accept: '*/*' },
    }
  );

  if (!response.ok) {
    throw new Error('Failed to fetch areas');
  }

  const result = await response.json();
  return result.data || [];
};


export const getFacilities = async () => {
  const response = await fetch(
    `${BASE_URL}/providerempanelment/GetFacility`,
    {
      method: 'GET',
      headers: { accept: '*/*' },
    }
  );

  if (!response.ok) {
    throw new Error('Failed to fetch facilities');
  }

  const result = await response.json();
  return result.data || [];
};


export const getSpecialties = async () => {
  const res = await fetch(
    `${BASE_URL}/providerempanelment/Specilties`,
    { headers: { accept: '*/*' } }
  );

  if (!res.ok) throw new Error('Failed to fetch specialties');

  const data = await res.json();
  return data.data || [];
};


export const getEmpanelmentByRefNo = async (refNo) => {
  if (!refNo) {
    throw new Error('Reference number is required');
  }

  const response = await fetch(
    `${BASE_URL}/providerempanelment/GetEmpanelment?empanelment_RefNo=${refNo}`,
    {
      method: 'GET',
      headers: {
        accept: '*/*',
      },
    }
  );

  if (!response.ok) {
    throw new Error('Failed to fetch empanelment details');
  }

  const result = await response.json();
  return result.data?.[0] || null; // Returns the first empanelment object or null
};


export const downloadEmpanelmentFile = async (refNo, fileName) => {
  if (!refNo || !fileName) {
    throw new Error('Reference number and file name are required');
  }

  const response = await fetch(
    `${BASE_URL}/providerempanelment/download-file?empanelment_RefNo=${refNo}&fileName=${encodeURIComponent(fileName)}`,
    {
      method: 'GET',
      headers: {
        accept: '*/*',
      },
    }
  );

  if (!response.ok) {
    throw new Error('Failed to download file');
  }

  // Convert response to Blob
  const blob = await response.blob();

  // Create download link
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;

  document.body.appendChild(link);
  link.click();

  // Cleanup
  link.remove();
  window.URL.revokeObjectURL(url);
};
